import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLegalIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M6.75 3.25H3M6.75 3.25C6.75 3.94036 7.30964 4.5 8 4.5M6.75 3.25C6.75 2.55964 7.30964 2 8 2C8.69036 2 9.25 2.55964 9.25 3.25M9.25 3.25H13M9.25 3.25C9.25 3.94036 8.69036 4.5 8 4.5M5.5 13.25H8M10.5 13.25H8M8 13.25V4.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M1.25 8.5L3.5 4.5L5.75 8.5M1.25 8.5V8.75C1.25 9.99264 2.25736 11 3.5 11C4.74264 11 5.75 9.99264 5.75 8.75V8.5M1.25 8.5H5.75" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.25 8.5L12.5 4.5L14.75 8.5M10.25 8.5V8.75C10.25 9.99264 11.2574 11 12.5 11C13.7426 11 14.75 9.99264 14.75 8.75V8.5M10.25 8.5H14.75" })
	]
});
export default SvgLegalIcon;
